/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon20Solid = forwardRef('ArrowUiAuthLoginIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2a3 3 0 0 0-3 3v4H2a1 1 0 1 0 0 2h4v4a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H9Zm-3 9 6.324-.001-2.394 2.394a1 1 0 0 0 1.414 1.414l3.273-3.273a2.172 2.172 0 0 0 0-3.071L11.344 5.19A1 1 0 1 0 9.93 6.604l2.394 2.395H6v2Z" })));
});
